import { COLLECT_ANSWER, COLLECT_FINAL_ANSWER } from "./types";
import firebase from "../firebase";
const {v4: uuidv4} = require('uuid')
function fillup(strIn) {
  if (!strIn) return '';
  
  var str = strIn.toString();
  
  // Replace spaces with underscores
  str = str.split(' ').join('_');
  
  // Remove or replace Firebase invalid characters
  // Firebase paths cannot contain: . # $ [ ] / and some special chars
  str = str.replace(/\./g, '_dot_')     // Replace periods
            .replace(/#/g, '_hash_')     // Replace hash
            .replace(/\$/g, '_dollar_')  // Replace dollar
            .replace(/\[/g, '_lbracket_') // Replace left bracket
            .replace(/\]/g, '_rbracket_') // Replace right bracket
            .replace(/\//g, '_slash_')   // Replace forward slash
            .replace(/%/g, '_percent_')  // Replace percent
            .replace(/\?/g, '_question_') // Replace question mark
            .replace(/</g, '_lt_')       // Replace less than
            .replace(/>/g, '_gt_')       // Replace greater than
            .replace(/"/g, '_quote_')    // Replace quotes
            .replace(/'/g, '_apostrophe_') // Replace apostrophes
            .replace(/\*/g, '_star_')    // Replace asterisk
            .replace(/\+/g, '_plus_')    // Replace plus
            .replace(/=/g, '_equals_')   // Replace equals
            .replace(/,/g, '_comma_')    // Replace comma
            .replace(/;/g, '_semicolon_') // Replace semicolon
            .replace(/:/g, '_colon_')    // Replace colon
            .replace(/\|/g, '_pipe_')    // Replace pipe
            .replace(/\\/g, '_backslash_') // Replace backslash
            .replace(/\(/g, '_lparen_')  // Replace left parenthesis
            .replace(/\)/g, '_rparen_')  // Replace right parenthesis
            .replace(/&/g, '_and_')      // Replace ampersand
            .replace(/\^/g, '_caret_')   // Replace caret
            .replace(/~/g, '_tilde_')    // Replace tilde
            .replace(/`/g, '_backtick_') // Replace backtick
            .replace(/@/g, '_at_')       // Replace at symbol
            .replace(/!/g, '_exclamation_'); // Replace exclamation
  
  // Limit length to prevent extremely long paths
  if (str.length > 100) {
    str = str.substring(0, 100);
  }
  
  return str;
}
export const appendAnswer = params => {
  if (params.type === COLLECT_ANSWER) {
    
    return (dispatch, getState) => {
        var valueID; //unique survey id for this group //uuidv4();
        var timeInMs = Date.now();
        var qnumber = params.questionNr+1;
        var newID;
        var OptionChosen = fillup(params.questionAnswer);
        //var OptionChosen = params.questionAnswer;
        var dbaseMain = firebase.database;
        var dbaseAppend = firebase.database;
        var dbaseFind = firebase.database;
        var valueID = params.surveyid;

        var i = 1;
        var x;  
        var isCompany;

        if (params.real_companyID) {
          isCompany = params.real_companyID;
        }
        else
        {
          isCompany = params.companyID;
        }

        var query = '/surveysAnalytics/' +isCompany+ '/' +valueID+ '/' +'Answer'+qnumber + '/' + OptionChosen;

        dbaseMain
        .ref(query) 
        .once("value")
        .then(snapshot => {
                  i = snapshot.val()+1;
          //////////////////////////////////////////////////////////////////////          
        if (qnumber!==1) { // everything after first answer
          if (qnumber !== 0) {
            var newID = params.surveyDone; //unique survey id carried over from first question
            var updates = {};
            updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +['Answer'+qnumber]+ '/' + [OptionChosen]] = i;
            updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +['Answer'+qnumber]+ '/' + 'thequestion'] = params.thequestion; 
            dbaseAppend
            .ref().update(updates);
          }
          else // qnumber = 0
          {
              newID = valueID; //FIRST RECORD; //unique survey id carried over from first question

              var updates = {};
              updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +'groupID'] = params.surveyid;
              dbaseMain
            .ref().update(updates)
            .then(() => {
              dispatch({
                type: COLLECT_ANSWER,
                surveyDone: newID,
                sgroupid: params.surveyid
              });
            })
            .catch(err => {
              dispatch({
                type: COLLECT_ANSWER,
                message: err.message
              });
            });          

            }

          //////////////////////////////////////////////////

          }
        else { // first entry do surveysData
          //newID = valueID; //FIRST RECORD
          var newID = params.surveyDone;

          var updates = {};
          updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +['Answer'+qnumber]+ '/' + 'thequestion'] = params.thequestion;       
          updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +'surveyDone'] = params.surveyDone;
          updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +'surveyid'] = params.surveyid;
          updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +'companyID'] = isCompany;
          //updates['surveysAnalytics/' + params.companyID + '/' + newID + '/' +'/groupID'] = params.groupID;
          updates['surveysAnalytics/' + isCompany + '/' + newID + '/' +['Answer'+qnumber]+ '/' + [OptionChosen]] = i;

          dbaseAppend
          .ref().update(updates)

          .then(() => {
    
            dispatch({
              type: COLLECT_ANSWER,
              surveyDone: newID,
              sgroupid: params.groupID
            });
          })
          .catch(err => {
            dispatch({
              type: COLLECT_ANSWER,
              message: err.message
            });
          });

        /////////////////////////////
       }

      })

      };
     }
    };
    